import moment from 'moment';
import { MONTH_FIRST_FORMATS, DAY_FIRST_FORMATS } from './dateFormats';
export var fixDateToFormat = function fixDateToFormat(value, format) {
  var customFormatList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var formats = [format];

  if (customFormatList.length !== 0 && customFormatList.includes(format)) {
    formats = customFormatList;
  } else if (format === 'MM/DD/YYYY') {
    formats = MONTH_FIRST_FORMATS;
  } else if (format === 'DD/MM/YYYY') {
    formats = DAY_FIRST_FORMATS;
  }

  if (!moment(value, formats, true).isValid()) {
    return null;
  }

  return moment(value, formats).format(format);
};
export default fixDateToFormat;